import { Link } from "@remix-run/react"
import { EyeOff } from "lucide-react"
import { Button } from "./Button"
import { CustomText } from "./CustomText"
import { DynamicIcon } from "./IconPicker"

interface InAppNotificationProps {
	notificationId: string
	title: string | null
	message: string
	ctaText: string | null
	link: string | null
	iconName: string | null
	isPreview?: boolean
	onDismiss: () => void
}

export function InAppNotification({
	notificationId,
	title,
	message,
	ctaText,
	link,
	iconName,
	isPreview = false,
	onDismiss,
}: InAppNotificationProps) {
	const handleCTAClick = () => {
		// Dismiss notification when CTA is clicked (navigation will happen via Link)
		onDismiss()
	}

	return (
		<>
			{/* Backdrop */}
			<div 
				className="fixed inset-0 bg-black/60 z-40" 
				onClick={onDismiss} 
			/>

			{/* Sheet */}
			<div className="fixed inset-x-0 bottom-0 z-50 bg-background rounded-t-2xl animate-slide-up">
				{/* Preview Mode Indicator */}
				{isPreview && (
					<div className="absolute top-3 right-3">
						<EyeOff className="size-5 text-foreground/60" />
					</div>
				)}
				{/* Header */}
				<div className="p-6 pb-6 text-center">
					{iconName && (
						<div className="flex justify-center mb-5">
							<DynamicIcon iconName={iconName} className="size-10 stroke-current" />
						</div>
					)}
					{title && (
						<h2 className="text-2xl font-bold capitalize tracking-wide mb-2">
							{title}
						</h2>
					)}
					<CustomText className="text-foreground/60 text-sm mt-2 max-w-xs mx-auto whitespace-pre-line">
						{message}
					</CustomText>
				</div>

				{/* CTA Button */}
				{ctaText && link && (
					<div className="px-4 pb-4">
						<Button asChild className="w-full">
							<Link to={link} onClick={handleCTAClick}>
								{ctaText}
							</Link>
						</Button>
					</div>
				)}

				{/* Close Button */}
				<div className="p-4 pt-2">
					<Button onClick={onDismiss} className="w-full">
						Close
					</Button>
				</div>
			</div>
		</>
	)
}

